module.exports = __webpack_public_path__ + "static/media/icn_menu_close.ccf81a22.svg";